 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({}[chunkId]||chunkId) + "." + {"chunk-021d5ecc":"0fecdd75","chunk-088ff9c4":"f2fede5a","chunk-0d13587f":"3fcc69e0","chunk-0f67ed0e":"62d3c0fe","chunk-2aebd3fb":"fbe65230","chunk-c61f3e78":"7b26455f","chunk-31fc9560":"fc9a5b9c","chunk-6af1bfdd":"1e73fdb5","chunk-713ff3a1":"a27e95a0","chunk-40674508":"0ac7869e","chunk-58e73ef6":"936fb3a4","chunk-127906ca":"23492607","chunk-1b973719":"d1fddfb7","chunk-200f5fc2":"5adcfa3f","chunk-222d5524":"f0bedc42","chunk-26b7f32c":"73a55c38","chunk-ae25ddb0":"4a16c2cc","chunk-2d0c0c33":"db5fa295","chunk-2d21a9a9":"fb9c0546","chunk-2d21f29d":"9d6ea177","chunk-2d22ce37":"8e549a1b","chunk-30b91178":"35817977","chunk-3f954034":"7cb80949","chunk-4a38101e":"03d4b842","chunk-4fb06232":"0151e30d","chunk-50274af8":"dd7c09e8","chunk-57e2746d":"5323a004","chunk-93275ae4":"31c2f818","chunk-6d0f6c29":"b767320c","chunk-70471c04":"c7703bf8","chunk-71db9392":"ac111723","chunk-7dad454a":"05f4d52e","chunk-839e8d0a":"afc852b8","chunk-bfb39cd6":"fbe3afaa","chunk-d86506f6":"0c86bb7e","chunk-e9918708":"20f6396b","chunk-ed75e97c":"0bf8fa96","chunk-2d237522":"412e5ee8","chunk-b7528f5c":"260a3148"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-021d5ecc":1,"chunk-088ff9c4":1,"chunk-0d13587f":1,"chunk-c61f3e78":1,"chunk-31fc9560":1,"chunk-6af1bfdd":1,"chunk-713ff3a1":1,"chunk-40674508":1,"chunk-58e73ef6":1,"chunk-127906ca":1,"chunk-1b973719":1,"chunk-200f5fc2":1,"chunk-222d5524":1,"chunk-ae25ddb0":1,"chunk-30b91178":1,"chunk-3f954034":1,"chunk-4a38101e":1,"chunk-4fb06232":1,"chunk-50274af8":1,"chunk-57e2746d":1,"chunk-93275ae4":1,"chunk-6d0f6c29":1,"chunk-70471c04":1,"chunk-71db9392":1,"chunk-7dad454a":1,"chunk-839e8d0a":1,"chunk-bfb39cd6":1,"chunk-d86506f6":1,"chunk-e9918708":1,"chunk-ed75e97c":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({}[chunkId]||chunkId) + "." + {"chunk-021d5ecc":"819dc80c","chunk-088ff9c4":"dcee3812","chunk-0d13587f":"bbc1b58c","chunk-0f67ed0e":"31d6cfe0","chunk-2aebd3fb":"31d6cfe0","chunk-c61f3e78":"bd1ea2e8","chunk-31fc9560":"a500b0e9","chunk-6af1bfdd":"6eea20eb","chunk-713ff3a1":"bddb2160","chunk-40674508":"cda986ca","chunk-58e73ef6":"e7ca2ece","chunk-127906ca":"746060f5","chunk-1b973719":"63f775ad","chunk-200f5fc2":"2cad8f0c","chunk-222d5524":"797087d6","chunk-26b7f32c":"31d6cfe0","chunk-ae25ddb0":"7fb6ee50","chunk-2d0c0c33":"31d6cfe0","chunk-2d21a9a9":"31d6cfe0","chunk-2d21f29d":"31d6cfe0","chunk-2d22ce37":"31d6cfe0","chunk-30b91178":"dc67a52d","chunk-3f954034":"f996b811","chunk-4a38101e":"dc4e5d6d","chunk-4fb06232":"c6b4ecff","chunk-50274af8":"95387096","chunk-57e2746d":"7cc7a79e","chunk-93275ae4":"72cebccf","chunk-6d0f6c29":"6b0686f5","chunk-70471c04":"4144b5da","chunk-71db9392":"d1bdea88","chunk-7dad454a":"5b4ee790","chunk-839e8d0a":"3fd2e09c","chunk-bfb39cd6":"5a42745a","chunk-d86506f6":"dcca3df0","chunk-e9918708":"476d3d6a","chunk-ed75e97c":"0e6e8c4d","chunk-2d237522":"31d6cfe0","chunk-b7528f5c":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://static.www.yuugeai.com/static/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
